import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  ErrorMessagesInterface,
  TextareaInterface,
} from '@modules/textarea/interfaces/textarea';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent implements OnInit, TextareaInterface {
  @Input() idTextarea: string | null = null;
  @Input() textCaption: string | null = null;
  @Input() placeholder: string = '';
  @Input() label: string | null = null;
  @Input() control: FormControl = new FormControl(null);
  @Input() errorMessages: ErrorMessagesInterface = {};
  @Input() successMessage: string | null = null;
  @Input() maxlength!: number;
  @Input() minlength!: number;

  public defaultErrors: ErrorMessagesInterface = {
    required: 'Este campo es obligatorio',
    minlength: 'Mínimo X caracteres.',
    maxlength: 'Máximo X caracteres.',
  };

  ngOnInit(): void {
    this.errorMessages = {
      ...this.defaultErrors,
      minlength: this.getMinLength(),
      maxlength: this.getMaxLength(),
      ...this.errorMessages,
    };
  }

  displayError(errors: {}) {
    return this.errorMessages[Object.keys(errors)[0]];
  }

  getMinLength() {
    return `Mínimo ${this.minlength} caracteres.`;
  }

  getMaxLength() {
    return `Máximo ${this.maxlength} caracteres.`;
  }
}
